export const formatDate = (locale: string, date: Date, options: Intl.DateTimeFormatOptions) => {
    return new Intl.DateTimeFormat(locale, options).format(date);
};

export const formatDateTime = (date: Date | string | null | undefined, locale: string = 'fr-FR') => {
    if (!date) return '-';
    
    try {
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        if (isNaN(dateObj.getTime())) return '-';
        
        return new Intl.DateTimeFormat(locale, { 
            year: 'numeric', 
            month: 'numeric', 
            day: 'numeric', 
            hour: 'numeric', 
            minute: 'numeric' 
        }).format(dateObj);
    } catch {
        return '-';
    }
};
